define("shared/utils/firebase", ["exports", "later/config/environment"], function (_exports, _environment) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/config/environment"eaimeta@70e063a35619d71f

  const developmentConfig = {
    apiKey: _environment.default.APP.firebaseDevKey,
    authDomain: 'fe-sandbox-8de2f.firebaseapp.com',
    projectId: 'fe-sandbox-8de2f',
    storageBucket: 'fe-sandbox-8de2f.appspot.com',
    messagingSenderId: '110185266989',
    appId: '1:110185266989:web:c0ef7bde60cbe318f8dda4',
    measurementId: 'G-PHGC8LY3QL',
    adminPassword: _environment.default.APP.firebaseAdminPw
  };
  const productionConfig = {
    apiKey: _environment.default.APP.firebaseProdKey,
    authDomain: 'fe-performance-monitoring.firebaseapp.com',
    projectId: 'fe-performance-monitoring',
    storageBucket: 'fe-performance-monitoring.appspot.com',
    messagingSenderId: '444836898119',
    appId: '1:444836898119:web:3388424621f94bdf8b5862',
    measurementId: 'G-K98KDML7D1',
    adminPassword: _environment.default.APP.firebaseAdminPw
  };
  let firebaseConfig;

  if (_environment.default.APP.environment === 'production') {
    firebaseConfig = productionConfig;
  } else {
    firebaseConfig = developmentConfig;
  }

  var _default = firebaseConfig;
  _exports.default = _default;
});